import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from "react";
import { StructuredData } from "./structured-data";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import Link from "next/link";
import { cn } from "@/lib/utils";
type BreadcrumbsLinkProps = {
  breadcrumbs: BreadcrumbsType[];
  className?: string;
};
export const Breadcrumbs = t0 => {
  const $ = _c(23);
  const {
    breadcrumbs: t1,
    className
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const breadcrumbs = t2;
  let t3;
  if ($[2] !== breadcrumbs) {
    t3 = breadcrumbs.length > 0 ? `Breadcrumbs for ${breadcrumbs.at(-1)?.label}` : "Breadcrumbs";
    $[2] = breadcrumbs;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== breadcrumbs) {
    t4 = breadcrumbs?.map(_temp);
    $[4] = breadcrumbs;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      name: t3,
      itemListElement: t4
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const breadcrumbSchema = t5;
  if (!breadcrumbs.length) {
    return null;
  }
  let t6;
  if ($[9] !== className) {
    t6 = cn("mb-10", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== breadcrumbs) {
    t7 = breadcrumbs.map(_temp2);
    $[11] = breadcrumbs;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <BreadcrumbList>{t7}</BreadcrumbList>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <Breadcrumb className={t6}>{t8}</Breadcrumb>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== breadcrumbSchema) {
    t10 = <StructuredData data={breadcrumbSchema} />;
    $[18] = breadcrumbSchema;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <Fragment>{t9}{t10}</Fragment>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(item, index, items) {
  return {
    "@type": "ListItem",
    position: index + 1,
    name: item.label,
    ...(index + 1 !== items.length && item.url && {
      item: process.env.NEXT_PUBLIC_APP_URL + item.url
    })
  };
}
function _temp2(item_0, idx, all) {
  return <Fragment key={`bredcrumb-${idx}`}><BreadcrumbItem>{item_0.url ? <BreadcrumbLink render={<Link href={item_0.url}>{item_0.label}</Link>} /> : <BreadcrumbPage>{item_0.label}</BreadcrumbPage>}</BreadcrumbItem>{idx + 1 !== all?.length && <BreadcrumbSeparator />}</Fragment>;
}